import { Helmet } from 'react-helmet-async';

const SEO = ({
  title = "Elderra | Bridging tech for the Elderly",
  description = "Empowering India's 70+ seniors with digital literacy training. Join 1500+ elderly citizens learning to navigate the digital world safely. Free training, DigiMitra home visits, and WhatsApp support across 50+ cities. I am 70+ and I don't share OTPs.",
  keywords = "elderly digital training India, senior citizens technology, digital literacy seniors, cyber safety elders, I am 70+ OTP awareness, DigiMitra home visits, senior tech education, elderly WhatsApp support, Elderra digital empowerment",
  ogImage = "https://customer-assets.emergentagent.com/job_95459019-fd40-417d-bf1f-43659b4169ce/artifacts/4owwqeky_Elderra%20Banner.png",
  ogUrl = "https://elderra.io",
  type = "website"
}) => {
  const siteName = "Elderra";
  const twitterHandle = "@Elderraio";
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="en_IN" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={ogUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      <meta property="twitter:site" content={twitterHandle} />
      <meta property="twitter:creator" content={twitterHandle} />
      
      {/* Additional SEO Tags */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="language" content="English" />
      <meta name="author" content="Elderra" />
      <meta name="geo.region" content="IN" />
      <meta name="geo.placename" content="India" />
      <link rel="canonical" href={ogUrl} />
      
      {/* Structured Data - Organization */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Elderra",
          "alternateName": "Elderra.io",
          "url": "https://elderra.io",
          "logo": "https://customer-assets.emergentagent.com/job_ab32166f-e481-4e95-8429-3d2fdf4d805e/artifacts/xbc2tl0f_Elderra%20logo%20new%20original%20%281%29.png",
          "description": "Empowering India's senior citizens (70+) with digital literacy and technology training. Bridging tech for elders.",
          "slogan": "Bridging Tech for Elders",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+91-77100-79100",
            "contactType": "customer service",
            "email": "helloelderra@gmail.com",
            "areaServed": "IN",
            "availableLanguage": ["English", "Hindi"]
          },
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "IN",
            "addressRegion": "India"
          },
          "sameAs": [
            "https://elderra.io"
          ],
          "areaServed": {
            "@type": "Country",
            "name": "India"
          }
        })}
      </script>
      
      {/* Structured Data - Local Business */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "EducationalOrganization",
          "name": "Elderra",
          "image": "https://customer-assets.emergentagent.com/job_95459019-fd40-417d-bf1f-43659b4169ce/artifacts/4owwqeky_Elderra%20Banner.png",
          "description": "Digital literacy training and empowerment for India's senior citizens",
          "telephone": "+91-77100-79100",
          "email": "helloelderra@gmail.com",
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "IN"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "addressCountry": "IN"
          },
          "url": "https://elderra.io"
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
